import React from "react"
import { Img } from "../shared/img"
import { useQueryParams } from "../../hooks/useQueryParams";
import { useEffect } from "react";
import { useState } from "react";
import { Icon } from "@iconify/react";
import { AppView } from "./app-view";
import { SesionAPI } from "../../services/api/Sesion";


export const Success = () => {
    const params = useQueryParams();
    const [authHash, setAuthHash] = useState(undefined);
    const [opened, setOpened] = useState(false);
    const [loading, setLoading] = useState(true);


    const handleSamlAndClasslinkAuth = async ()=>{
        setLoading(true);
        console.log('SAML/CLASSLINK AUTH');
        await SesionAPI.generateAuthHash({abortSignal:null})
        .then(result=>{
            if(result){
                setAuthHash(result);
            }
        })
        .catch(error=>console.log(error))
        .finally(()=>{
            setLoading(false);
        })
    }
    useEffect(() => {
        const _authHash = params.get('hash');
        const authType = params.get('access');
        if (_authHash) {
            if(authType === 'saml_classlink' && _authHash==='0'){
                handleSamlAndClasslinkAuth();
            }else{
                setLoading(false);
                console.log('ANOTHER TYPE OF AUTH');
                setAuthHash(_authHash);
            }
        } else {
            window.location.replace('/home');
        }
    }, [params])

    const openApp = ()=>{
        setOpened(true)
        window.location.replace(`${window.location.origin}/external-auth/app?hash=${authHash}`);
    }


    return (
        <>
            {opened === false ?
                <div className="w-100 min-vh-100 secondary--bg  p-2">
                    {
                        loading ?
                            <div className="w-100 min-vh-100 d-flex flex-column justify-content-center align-items-center">
                                <Img className="img-fluid m-2 my-3" src="\img\logo-makemake.png" style={{ maxWidth: 200 }} />
                                <p className="onsecondary--color" style={{fontWeight:700}}>Verificando sesión, por favor espera...</p>
                                <Icon icon="fa:spinner" className={'spinner-rotation m-3 onsecondary--color'} width={35} />
                            </div>
                            :
                            <div className="container d-flex flex-column align-items-center">
                                <Img className="img-fluid m-2 my-3" src="\img\logo-makemake.png" style={{ maxWidth: 200 }} />
                                <h1 className="onsecondary--color text-center">¡Ingreso exitoso!</h1>
                                <p className="onsecondary--color m-2 text-center">Puedes disfrutar de MakeMake en tu celular dando clic al siguiente enlace. Recuerda que debes mantener esta ventana abierta hasta completar el ingreso.</p>
                                {
                                    authHash &&
                                    <>
                                        <button className="btn btn-primary m-3" onClick={() => openApp()}>Abrir aplicación</button>
                                        <p className="primary--color m-2 text-center" style={{ fontWeight: 700, fontSize: 13 }}>Verifica que tu dispositivo tenga instalada la App de MakeMake.</p>
                                        <div className="row" style={{ maxWidth: 350 }}>
                                            <a href={'https://apps.apple.com/co/app/apple-store/id375380948'} className="col-12 btn btn-light my-2  p-2 text-left"  ><Icon icon="ri:apple-fill" width={30} /> Instalación en iOS</a>
                                            <a href={'https://play.google.com/store/apps'} className="col-12 btn btn-light p-2 text-left" > <Icon icon="uil:android" width={30} /> Instalación en Android</a>
                                        </div>
                                    </>
                                }
                            </div>

                    }

                </div> : <AppView />
            }
        </>
    )

}